import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  li {\n    color: ",
        ";\n    line-height: 22px;\n    list-style: initial;\n    margin-inline-start: 24px;\n  }\n\n  @media (max-width: 768px) {\n    li {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  .priceInfo {\n    display: flex;\n    align-items: center;\n    @media (max-width: 768px) {\n      display: flex;\n      align-items: flex-start;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  padding: 24px;\n  border-radius: 6px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n\n  :hover {\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.04);\n    transition: box-shadow 0.3s ease-in-out;\n  }\n\n  .ant-row {\n    width: 100%;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    gap: 40px;\n    align-items: center;\n  }\n\n  .ant-col {\n    align-items: center;\n\n    &.clickArea {\n      cursor: pointer;\n      flex: 1;\n    }\n\n    &.priceInfo {\n      text-align: right;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      height: 52px;\n\n      .left {\n        height: 100%;\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        margin-right: 24px;\n      }\n\n      .right {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 20px;\n    .ant-row {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    .ant-col.priceInfo {\n      align-items: flex-end;\n    }\n\n    .ant-col {\n      &.priceInfo {\n        .left {\n          justify-content: flex-end;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { BOOKS_LANDING, EBOOKS_LANDING, PASSES_LANDING } from "@/settings/constant";
import { styled as muiStyled } from "@mui/material";
import { useRouter } from "next/router";
import { useMemo } from "react";
import styled from "styled-components";
import FilledButton from "../common/Button/FilledButton";
export const getIsPasses = (pathname)=>pathname.startsWith(PASSES_LANDING);
export const usePasses = ()=>{
    const { pathname  } = useRouter();
    const { isPasses  } = useMemo(()=>{
        return {
            isPasses: getIsPasses(pathname)
        };
    }, [
        pathname
    ]);
    return {
        isPackages: isPasses
    };
};
export const useProductType = ()=>{
    const { pathname  } = useRouter();
    // Todo 로직 수정 필요
    const { productType  } = useMemo(()=>{
        let productType;
        switch(pathname.split("/")[1]){
            case EBOOKS_LANDING:
                productType = "ebooks";
                break;
            case PASSES_LANDING:
                productType = "package";
                break;
            case BOOKS_LANDING:
                productType = "aladinbooks";
                break;
        }
        return {
            productType
        };
    }, [
        pathname
    ]);
    return {
        productType
    };
};
export const Title = muiStyled("h5")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.grey[900],
        marginBottom: "24px",
        ...theme.typography.h4,
        "& em": {
            color: theme.palette.indigo[500],
            textDecoration: "none"
        },
        [theme.breakpoints.down(820)]: {
            marginBottom: "20px"
        }
    };
});
export const SubTitle = muiStyled("h5")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["title"],
        marginBottom: "20px",
        ...theme.typography.h6,
        "& span": {
            color: theme.palette.text["secondary"],
            marginInlineStart: "4px",
            ...theme.typography.body2
        },
        [theme.breakpoints.down("sm")]: {
            "& span": {}
        }
    };
});
export const Container = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        // marginBottom: '40px',
        ".notice-title": {
            color: theme.palette.grey[500],
            fontWeight: "600",
            marginBottom: "8px"
        },
        [theme.breakpoints.down("sm")]: {
            gap: "40px"
        }
    };
});
export const NoticeList = styled.ul.withConfig({
    componentId: "sc-a671e49d-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_500);
export const OriginalPrice = muiStyled("s")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["disabled"],
        ...theme.typography.body2,
        [theme.breakpoints.down("sm")]: {
            textAlign: "left"
        }
    };
});
export const DiscountRate = muiStyled("em")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.red[400],
        marginInlineEnd: "4px",
        ...theme.typography.h6,
        [theme.breakpoints.down("sm")]: {}
    };
});
export const Price = muiStyled("p")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["primary"],
        textAlign: "right",
        whiteSpace: "nowrap",
        ...theme.typography.h6,
        [theme.breakpoints.down("sm")]: {
            textAlign: "left"
        }
    };
});
export const PassTitle = muiStyled("h5")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["primary"],
        marginBottom: "4px",
        maxWidth: "380px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        "-webkit-box-orient": "vertical",
        wordBreak: "break-all",
        ...theme.typography.h6,
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column-reverse",
            alignItems: "flex-start"
        }
    };
});
export const PassPrice = styled.div.withConfig({
    componentId: "sc-a671e49d-1"
})(_templateObject1());
export const PassItemContainer = styled.li.withConfig({
    componentId: "sc-a671e49d-2"
})(_templateObject2(), (pass)=>pass.theme.new.colors.white, (pass)=>pass.theme.new.colors.sol_gray_100);
export const SubDescription = muiStyled("span")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text["secondary"],
        display: "flex",
        alignItems: "center",
        ...theme.typography.body1
    };
});
export const OrderFilledButton = muiStyled(FilledButton)((param)=>{
    let { theme  } = param;
    return {
        padding: "10px 16px",
        ...theme.typography.subtitle2
    };
});
export const PurchaseButton = (param)=>{
    let { onClick , children  } = param;
    return /*#__PURE__*/ _jsx(OrderFilledButton, {
        type: "text",
        variant: "outlined",
        className: "cart-btn",
        onClick: onClick,
        children: children
    });
};
export const SubscribeButton = (param)=>{
    let { onClick , children  } = param;
    return /*#__PURE__*/ _jsx(OrderFilledButton, {
        type: "text",
        variant: "solid",
        className: "cart-btn",
        onClick: onClick,
        children: children
    });
};
